import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Seo from "@/components/feature/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="页面不存在 · 瓜田观察站"
        description="你访问的页面不存在，返回瓜田观察站首页或事件档案库，继续查看网络热点事件的时间线整理。"
        keywords="页面不存在,返回首页,事件档案库"
        path={location.pathname}
      />
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4 py-32">
        <div className="text-center">
          <p className="font-display text-6xl text-primary-200 md:text-8xl">404</p>
          <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这条瓜迷路了
          </h1>
          <p className="mt-3 font-body text-sm text-foreground-600">
            你要找的页面不存在，或者是链接已经更新。
          </p>
          <p className="mt-1 font-label text-xs text-foreground-400">{location.pathname}</p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link to="/" className="btn-primary w-full sm:w-auto">
              返回首页
            </Link>
            <Link to="/topics" className="btn-secondary w-full sm:w-auto">
              浏览事件档案
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}